import { makeStyles } from "@material-ui/core/styles";

export function useEmptyStateStyles() {
  const useStyles = makeStyles((theme) => ({
    root: {
      textAlign: "center",
      padding: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    icon: {
      fontSize: 30,
      marginBottom: theme.spacing(1),
      color: theme.palette.action.disabled,
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
